import React, { useState } from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { Button } from '../ui/Button';
import { motion } from 'framer-motion';
import { useStore } from '../store/usestore';
import { Link } from 'react-router-dom';

export const Members = () => {
  const { members } = useStore();

  return (
    <SectionWrapper id="members" className="bg-white">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">NWC MEMBERS</h2>
        <p className="text-gray-600 max-w-2xl mx-auto mb-8">
          Our strength lies in our people. Meet the full team dedicated to our grassroots mobilization efforts.
        </p>
        <Link to="/active-members">
          <Button variant="outline" className="border-primary text-primary hover:bg-primary hover:text-white">
            View Members
          </Button>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
        {members.slice(0, 4).map((member) => (
          <MemberCard key={member.id} member={member} />
        ))}
      </div>
    </SectionWrapper>
  );
};

const MemberCard = ({ member }: { member: { id: number; name: string; title?: string; role: string; image: string } }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <motion.div
      whileHover={{ y: -5 }}
      className="bg-white border border-gray-200 rounded-xl p-6 flex flex-col items-center text-center shadow-sm hover:shadow-md transition-all hover:border-primary"
    >
      <div className="w-full aspect-square rounded-lg overflow-hidden mb-4 bg-gray-100">
        <motion.img 
          src={member.image} 
          alt={member.name} 
          className="w-full h-full object-cover"
          initial={{ opacity: 0 }}
          animate={{ opacity: imageLoaded ? 1 : 0 }}
          transition={{ duration: 0.5 }}
          onLoad={() => setImageLoaded(true)}
          loading="lazy"
          decoding="async"
        />
      </div>
      <h3 className="font-bold text-gray-900">{member.name}</h3>
      {member.title && <p className="text-sm font-medium text-primary">{member.title}</p>}
      <p className="text-sm text-gray-500">{member.role}</p>
    </motion.div>
  );
};
